var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 325.1 262.8",
    style: {
      enableBackground: "new 0 0 325.1 262.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CFCFCF;}\n\t.st1{fill:#F2F2F2;}\n\t.st2{fill:#D2D2D2;}\n\t.st3{fill:#FFFFFF;stroke:#BABABA;stroke-width:2.4428;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{fill:none;stroke:#BABABA;stroke-width:2.4428;stroke-linecap:round;stroke-linejoin:round;}\n\t.st5{fill:#BABABA;}\n\t.st6{fill:#D2D2D2;stroke:#D2D2D2;stroke-width:2.4428;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.4,188c1.3,0,2.4-1.1,2.4-2.4c0-1.3-1.1-2.4-2.4-2.4s-2.4,1.1-2.4,2.4C56,186.9,57.1,188,58.4,188z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M213.7,87.9c-20.4,0-41.3-0.8-60.7-6.3c-19.1-5.3-36.6-15.6-52.3-27.5c-10.2-7.7-19.5-13.9-32.8-13 c-13,0.7-25.4,5.6-35.5,13.9C15.5,69.8,18,97.3,24.8,116.5c10.2,29,41.1,49.2,67.4,62.3c30.4,15.2,63.7,24,97.2,29 c29.3,4.5,67,7.7,92.4-11.4c23.3-17.6,29.7-57.8,24-84.9c-1.4-8-5.7-15.2-12-20.3c-16.4-12-40.8-4-59.3-3.6 C227.6,87.7,220.7,87.9,213.7,87.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M171.1,210.8c15.2,0,27.6-12.3,27.6-27.6c0-15.2-12.3-27.6-27.6-27.6c-15.2,0-27.6,12.3-27.6,27.6 C143.5,198.4,155.9,210.8,171.1,210.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M142.6,11c1.5-0.3,3.1-0.4,4.6-0.1c1.5,0.3,3,0.8,4.3,1.7c1.3,0.8,2.5,1.9,3.4,3.2c0.9,1.3,1.5,2.7,1.9,4.2 l4.4,19.8L137.9,45l-4.4-19.8c-0.3-1.5-0.4-3.1-0.1-4.7c0.3-1.5,0.8-3,1.7-4.3c0.8-1.3,1.9-2.5,3.2-3.4 C139.6,12,141.1,11.4,142.6,11z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M251.3,166.1l-141.4,31.5c-0.9,0.2-1.8,0.2-2.7-0.1c-0.9-0.3-1.6-0.7-2.3-1.4c-0.6-0.7-1.1-1.5-1.3-2.3 c-0.2-0.9-0.2-1.8,0.1-2.7l0.6-2c4.9-17.3,9.1-36.4,5.2-54l-8.4-37.5c-7-31.5,11.9-63.7,43.2-71.4c7.6-1.9,15.6-2.2,23.4-1 c7.8,1.2,15.2,4,21.9,8.1c6.7,4.1,12.5,9.6,17.1,16c4.6,6.4,7.8,13.7,9.5,21.4l8.6,38.8c3.9,17.6,15.8,33.1,27.7,46.7l1.4,1.6 c0.6,0.7,0.9,1.5,1.1,2.4c0.2,0.9,0.1,1.8-0.2,2.6c-0.3,0.8-0.8,1.6-1.4,2.2C253,165.5,252.2,165.9,251.3,166.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M146.7,141.9c0-5.7,1.9-11.3,5.4-15.7c3.6-4.5,8.5-7.6,14.1-8.8c5.6-1.2,11.4-0.5,16.5,2 c5.1,2.5,9.2,6.7,11.6,11.9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M190.4,102.3c1.9,0,3.5-1.6,3.5-3.5c0-1.9-1.6-3.5-3.5-3.5c-1.9,0-3.5,1.6-3.5,3.5 C186.9,100.7,188.4,102.3,190.4,102.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M136.6,114.3c1.9,0,3.5-1.6,3.5-3.5s-1.6-3.5-3.5-3.5s-3.5,1.6-3.5,3.5S134.6,114.3,136.6,114.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.2,7.4c1.3,0,2.4-1.1,2.4-2.4c0-1.3-1.1-2.4-2.4-2.4s-2.4,1.1-2.4,2.4C198.9,6.3,199.9,7.4,201.2,7.4z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.4,188c1.3,0,2.4-1.1,2.4-2.4c0-1.3-1.1-2.4-2.4-2.4s-2.4,1.1-2.4,2.4C56,186.9,57.1,188,58.4,188z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M267.4,62.8v10.5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M262.1,68h10.5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M272.2,220.9v10.5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M266.9,226.2h10.5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M88.5,23v10.5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M83.3,28.2h10.5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164.6,255.3c49.5,0,89.7-2.5,89.7-5.6c0-3.1-40.1-5.6-89.7-5.6S75,246.6,75,249.7 C75,252.8,115.1,255.3,164.6,255.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M250.3,56.8c0,7.4-3,14.6-8.2,19.8c-5.3,5.3-12.4,8.2-19.8,8.2c-0.9,0-1.8,0-2.7-0.1l-8.3,13.6l-2.6-17 c-4.3-2.4-7.9-5.9-10.4-10.1c-2.5-4.2-3.9-9.1-3.9-14c-0.1-4.9,1.2-9.8,3.6-14.1s6-7.9,10.2-10.4c4.3-2.5,9.1-3.8,14-3.8 c4.9,0,9.8,1.3,14.1,3.7c4.3,2.5,7.8,6,10.3,10.3C249,47.1,250.3,51.9,250.3,56.8L250.3,56.8z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.3,59.7c1.6,0,2.8-1.3,2.8-2.8c0-1.6-1.3-2.8-2.8-2.8c-1.6,0-2.8,1.3-2.8,2.8 C207.5,58.4,208.7,59.7,210.3,59.7z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M222.3,59.7c1.6,0,2.8-1.3,2.8-2.8c0-1.6-1.3-2.8-2.8-2.8s-2.8,1.3-2.8,2.8C219.4,58.4,220.7,59.7,222.3,59.7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M234.2,59.7c1.6,0,2.8-1.3,2.8-2.8c0-1.6-1.3-2.8-2.8-2.8s-2.8,1.3-2.8,2.8C231.4,58.4,232.7,59.7,234.2,59.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotification);
export default __webpack_public_path__ + "static/media/no-notification.35951c3f01f57afca75e581a6540c7f4.svg";
export { ForwardRef as ReactComponent };